import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractList} from '../abstract-list';
import {LawyerFilter, LawyerSettings} from './filter';
import {GeneralUtility} from '../../utilities/general-utility';

/**
 * Lawyer quotes.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Quotes extends AbstractList<LawyerFilter, LawyerSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('lawyer-quotes', this);
  }

  /**
   * Finds lawyer quotes.
   */
  protected find(): void {
    DataApi.instance.lawyerEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        let i = 0;
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/lawyer/quote.handlebars');
          html += template({
            document: document,
            isLast: i === response.documents.length - 1,
            iteration: i++
          });
        }
        this.update(html);

        // Load first lazy-image-sourceset immediately
        const firstQuote = this.resultContainer?.querySelector<HTMLElement>('.carousel-item');
        if (firstQuote) {
          GeneralUtility.loadLazyImageSourcesets(firstQuote);
        }

        // Listen to Bootstrap carousel slide-changes, to lazy-load new images
        const carouselContainer = this.container.querySelector('.carousel');
        if (carouselContainer) {
          carouselContainer.addEventListener('slide.bs.carousel', e => {
            GeneralUtility.loadLazyImageSourcesets(e.relatedTarget as HTMLElement);
          });
        }

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
